import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Zap, Pencil, Trash2, Link2 } from "lucide-react";

export function QuickCapture({ items, boards, onAdd, onToggle, onEdit, onDelete, onMove }) {
  const [text, setText] = useState("");
  const checklists = (boards || []).flatMap((b) => b.checklists.map((c) => ({ id: c.checklist_id, label: `${b.title} › ${c.title}` })));

  const submit = (e) => { e.preventDefault(); const t = text.trim(); if (!t) return; onAdd(t); setText(""); };

  return (
    <div className="rounded-xl border border-slate-200 bg-white p-4" data-testid="quick-capture">
      <div className="flex items-center gap-2 mb-3">
        <Zap className="h-4 w-4 text-amber-500" />
        <span className="overline">Quick Capture</span>
        <span className="text-xs text-slate-400">Jot it down now, organise later</span>
      </div>
      <form onSubmit={submit} className="flex gap-2">
        <Input value={text} onChange={(e) => setText(e.target.value)} placeholder="Write something… e.g. Call XinRong about Chanel sample" className="h-9" data-testid="quick-capture-input" />
        <Button type="submit" className="bg-[#2563EB] hover:bg-[#1d4ed8] h-9" disabled={!text.trim()} data-testid="quick-capture-add">Add</Button>
      </form>

      {items.length > 0 && (
        <div className="mt-3 space-y-1.5" data-testid="quick-capture-list">
          {items.map((i) => (
            <div key={i.todo_id} className="flex items-center gap-2 rounded-lg border border-slate-100 bg-slate-50/60 px-2.5 py-1.5" data-testid={`capture-item-${i.todo_id}`}>
              <Checkbox checked={i.completed} onCheckedChange={(c) => onToggle(i, !!c)} data-testid={`capture-toggle-${i.todo_id}`} />
              <span className={`flex-1 text-sm ${i.completed ? "line-through text-slate-400" : "text-slate-800"}`}>{i.title}</span>
              {checklists.length > 0 && (
                <Select onValueChange={(v) => onMove(i, v)}>
                  <SelectTrigger className="h-7 w-[150px] text-xs border-slate-200" data-testid={`capture-move-${i.todo_id}`}><Link2 className="h-3 w-3 mr-1" /><SelectValue placeholder="Move to…" /></SelectTrigger>
                  <SelectContent>{checklists.map((c) => <SelectItem key={c.id} value={c.id} className="text-xs">{c.label}</SelectItem>)}</SelectContent>
                </Select>
              )}
              <button className="text-slate-400 hover:text-slate-700" onClick={() => onEdit(i)} data-testid={`capture-edit-${i.todo_id}`}><Pencil className="h-3.5 w-3.5" /></button>
              <button className="text-slate-400 hover:text-red-600" onClick={() => onDelete(i)} data-testid={`capture-delete-${i.todo_id}`}><Trash2 className="h-3.5 w-3.5" /></button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
